import { Badge, Card, CardBody, Row, Col, Spinner, Table } from "reactstrap"
import { useAccountLoanSummary } from "hooks/useAccountLoan"
import { formatReadableDate } from "utils/formatDate"
import { formatCurrency } from "utils/formatCurrency"
import WorkspaceStatCard from "pages/AccountPages/AccountWorkspace/components/WorkspaceStatCard"

const LoanSummaryCard = ({ borrowerType, borrowerId }) => {
  const { data, isLoading } = useAccountLoanSummary(borrowerType, borrowerId, Boolean(borrowerId))
  const summary = data?.data || {}
  const loans = summary.loans || []

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <Spinner size="sm" />
      </div>
    )
  }

  return (
    <div>
      <Row className="g-3 mb-3">
        <Col md={4}>
          <WorkspaceStatCard
            title="Total Borrowed"
            value={formatCurrency(summary.total_amount || 0, "BDT")}
            icon="mdi mdi-cash-multiple"
            color="primary"
          />
        </Col>
        <Col md={4}>
          <WorkspaceStatCard
            title="Total Repaid"
            value={formatCurrency(summary.total_repaid || 0, "BDT")}
            icon="mdi mdi-cash-check"
            color="success"
          />
        </Col>
        <Col md={4}>
          <WorkspaceStatCard
            title="Outstanding"
            value={formatCurrency(summary.total_outstanding || 0, "BDT")}
            icon="mdi mdi-finance"
            color={summary.total_outstanding > 0 ? "warning" : "success"}
          />
        </Col>
      </Row>

      <Card className="border-0 shadow-sm">
        <CardBody className="p-3">
          <h6 className="fw-semibold mb-3">
            <i className="mdi mdi-format-list-bulleted me-2" />
            Loans
          </h6>
          {loans.length ? (
            <div className="table-responsive">
              <Table className="align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Date</th>
                    <th>Account</th>
                    <th className="text-end">Amount</th>
                    <th className="text-end">Remaining</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loans.map(loan => (
                    <tr key={loan.id}>
                      <td className="text-muted">
                        {loan.loan_date ? formatReadableDate(loan.loan_date, "MMM d, y") : "-"}
                      </td>
                      <td>{loan.account?.name || "-"}</td>
                      <td className="text-end">{formatCurrency(loan.amount, "BDT")}</td>
                      <td className="text-end">
                        <Badge
                          className={`badge-soft-${loan.remaining > 0 ? "warning" : "success"}`}
                        >
                          {formatCurrency(loan.remaining ?? 0, "BDT")}
                        </Badge>
                      </td>
                      <td>{loan.loan_status?.name || loan.loanStatus?.name || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-muted small">No loans recorded.</div>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

export default LoanSummaryCard
